export var name = "@atlaskit/editor-core";
export var version = "214.2.0";